import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getUserSkills } from "../services/skills.service";
import { userKeys } from "../queryKeys";
import { SkillsResponse } from "../types/skills.types";

export const useUserSkills = (userId: string | null) => {
  const { i18n } = useTranslation();

  return useQuery<SkillsResponse["data"], Error>({
    queryKey: [...userKeys.skills(userId!), i18n.language],
    queryFn: async () => {
      const response = await getUserSkills(userId!);
      return response.data;
    },
    enabled: !!userId,
  });
};
